import React, { useEffect, useState } from "react";
import { getAppAboutUsData } from "services/apiService";
import Gif_Image from "../../assect/construction.gif";
import { BUILD_DATE, PACKAGE_CODE, VERSION } from "../../info";

interface AboutUsData {
  message: string;
}

const AboutUsList = () => {
  const [appAboutUsData, setAppAboutus] = useState<AboutUsData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    getAppAboutus();
  }, []);

  const getAppAboutus = async () => {
    try {
      const response = await getAppAboutUsData();
      setAppAboutus({ message: response.data });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const appDetails = {
    version: VERSION,
    buildDate: BUILD_DATE,
    packageCode: PACKAGE_CODE,
  
  };
  const engineDetails = appAboutUsData?.message
  ?.split(",")
  ?.map((item) => item.split(":")?.map((part) => part?.trim()))
  ?.filter(([key, value]) => key && value);
  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-90">
      {loading ? (
        <div className="text-center">
          <img src={Gif_Image} alt="Loading..." width={100} />
          <p>Loading Engine Status...</p>
        </div>
      ) : (

      <div className="card shadow-lg border-0 rounded app-info-card">
        <div className="card-body bg-dark text-white">
          <h5 className="card-title fw-bold text-center mb-4">APP INFO</h5>
          <p className="pb-2 fw-bold text-danger">FRONTEND</p>
          <table className="table table-dark table-bordered mb-0">
          <tbody>
            <tr>
                <th>Package Code</th>
                <td>{appDetails.packageCode}</td>
              </tr>
              <tr>
                <th>Version</th>
                <td>{appDetails.version} </td>
              </tr>
              <tr>
                <th>Release Date</th>
                <td>{appDetails.buildDate}</td>
              </tr>
             
              
              
            </tbody>
          </table>
          {engineDetails?.length > 0 && (
            <>
              <p className="pb-2 pt-5 fw-bold text-danger">BACKEND</p>
              <table className="table table-dark table-bordered mb-0">
                <tbody>
                  {engineDetails?.map(([key, value], index) => (
                    <tr key={index}>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                          textTransform: "capitalize",
                          padding: "5px 25px",
                        }}
                      >
                        {key}
                      </th>
                      <td>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
      )}
    </div>
  );
};

export default AboutUsList;
